export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col gap-1.5 sm:flex-row sm:items-center sm:justify-between mb-7" data-testid="page-header">
    <div>
      <h1
        className="text-[22px] font-semibold tracking-tight text-slate-900"
        style={{ fontFamily: 'Space Grotesk, sans-serif' }}
      >
        {title}
      </h1>
      {subtitle && (
        <p className="text-[13px] text-slate-400 mt-0.5">{subtitle}</p>
      )}
    </div>
    {children && <div className="flex items-center gap-2 mt-3 sm:mt-0">{children}</div>}
  </div>
);
